import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as registrationActions from '../../actions/registrationActions';
import { registrationSelector } from '../../selectors';
import { ChangeEmail } from '../../components/auth';
import { Modal, Button, Header } from 'semantic-ui-react';

class ChangeEmailPage extends Component {
	constructor(props) {
		super(props);
		this.onFieldChange = this.onFieldChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onConfirm = this.onConfirm.bind(this);
	}
	onFieldChange(e) {
		const user = { ...this.props.registration.user };
		user[e.target.name] = e.target.value;
		this.props.actions.updateUserRegistration(user);
	}
	onSubmit(e) {
		const { username } = { ...this.props.registration.user };
		this.props.actions.changeEmail({  newEmail: username });
	}
	onConfirm() {
		this.props.actions.hideEmailChangedBox();
	}
	render() {
		const { user } = this.props.registration;
		return (
			<div>
				<Header as='h3' content='Change Username (email address)' color='red' />
				<Modal open={user.emailChanged}>
					<Modal.Header content='Email Changed' />
					<Modal.Content content='Check your email to confirm the new email address. Your email address will not be changed until it is verified.' />
					<Modal.Actions actions={[<Button key='1' primary content='OK' onClick={this.onConfirm} />]} />
				</Modal>
				<ChangeEmail onSubmit={this.onSubmit} onChange={this.onFieldChange} loading={user.loading} error={user.error} data={user} />
			</div>
		);
	}
}

ChangeEmailPage.propTypes = {
	actions: PropTypes.object.isRequired,
	registration: PropTypes.object.isRequired
};

const mapStateToProps = (state, ownProps) => {
	return {
		registration: registrationSelector(state)
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		actions: {
			...bindActionCreators(registrationActions, dispatch)
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangeEmailPage);
